import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./features/home/home-page").then((m) => m.HomePage),
    title: "Phindi — Encontrá tu propiedad",
  },
  {
    path: "buscador",
    loadComponent: () =>
      import("./features/buscador/buscador-page").then((m) => m.BuscadorPage),
    title: "Phindi — Buscador de propiedades",
  },
  {
    path: "propiedades/:id",
    loadComponent: () =>
      import("./features/ficha/ficha-propiedad").then((m) => m.FichaPropiedad),
    title: "Phindi — Ficha de propiedad",
  },
  {
    path: "contacto",
    loadComponent: () =>
      import("./features/contacto/contacto-page").then((m) => m.ContactoPage),
    title: "Phindi — Contacto",
  },

  // El comodín va SIEMPRE último: Angular resuelve por orden, así que
  // cualquier ruta declarada debajo queda inalcanzable (era lo que se comía
  // /contacto y lo mandaba a la home).
  { path: "**", redirectTo: "" },
];
